module.exports = __webpack_public_path__ + "img/icon-facebook-circle-white.5c6470bb.svg";